'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function BWFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-drp37im9n", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-scxfwuset", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-d6qnp227k" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-d6qnp227k", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-drp37im9n)" }, /* @__PURE__ */ React.createElement("use", { fill: "#42addf", xlinkHref: "#mantine-d6qnp227k" }), /* @__PURE__ */ React.createElement("path", { fill: "#58a5ff", d: "M0 0h32v8H0z", mask: "url(#mantine-scxfwuset)" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#272727",
        stroke: "#f7fcff",
        strokeWidth: "2",
        d: "M-1 9h34v6H-1z",
        mask: "url(#mantine-scxfwuset)"
      }
    )))
  );
}

export { BWFlag };
//# sourceMappingURL=BW.mjs.map
